import { Save } from "lucide-react";
import { SUN, INK, CREAM } from "./config";

const inputStyle = { background: "rgba(255,255,255,0.08)", color: CREAM, border: "1px solid rgba(255,255,255,0.2)" };

export function SaveQuoteForm({ quoteForm, setQuoteForm, savingQuote, onSave }) {
  if (!quoteForm.open) return null;
  return (
    <div
      className="mt-4 p-4 rounded-lg"
      style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.15)" }}
      data-testid="save-quote-form"
    >
      {quoteForm.saved ? (
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <p className="text-sm font-semibold" style={{ color: SUN }}>Quote saved.</p>
            <p className="text-xs opacity-70 mt-1">Colin will follow up with next steps.</p>
          </div>
          <button
            type="button"
            onClick={() => setQuoteForm({ open: false, email: "", name: "", org: "", note: "", saved: null })}
            className="pcp-mono text-[11px] px-3 py-1.5 rounded"
            style={{ border: `1px solid ${CREAM}`, color: CREAM }}
            data-testid="save-quote-reset"
          >
            Save another
          </button>
        </div>
      ) : (
        <>
          <p className="text-xs opacity-80 mb-3">
            Save this configuration so Colin can pick up the follow-up. Email is optional but recommended.
          </p>
          <div className="grid md:grid-cols-3 gap-3">
            <input
              type="text"
              value={quoteForm.name}
              onChange={(e) => setQuoteForm((f) => ({ ...f, name: e.target.value }))}
              placeholder="Your name"
              className="px-3 py-2 rounded-md text-sm"
              style={inputStyle}
              data-testid="save-quote-name"
            />
            <input
              type="email"
              value={quoteForm.email}
              onChange={(e) => setQuoteForm((f) => ({ ...f, email: e.target.value }))}
              placeholder="you@company.com"
              className="px-3 py-2 rounded-md text-sm"
              style={inputStyle}
              data-testid="save-quote-email"
            />
            <input
              type="text"
              value={quoteForm.org}
              onChange={(e) => setQuoteForm((f) => ({ ...f, org: e.target.value }))}
              placeholder="Organization"
              className="px-3 py-2 rounded-md text-sm"
              style={inputStyle}
              data-testid="save-quote-org"
            />
          </div>
          <textarea
            value={quoteForm.note}
            onChange={(e) => setQuoteForm((f) => ({ ...f, note: e.target.value }))}
            placeholder="Optional note for Colin (context, timing, questions)…"
            rows={2}
            className="w-full mt-3 px-3 py-2 rounded-md text-sm resize-none"
            style={inputStyle}
            data-testid="save-quote-note"
          />
          <div className="mt-3 flex justify-end gap-2">
            <button
              type="button"
              onClick={() => setQuoteForm((f) => ({ ...f, open: false }))}
              className="pcp-mono text-[11px] px-3 py-1.5 rounded"
              style={{ color: CREAM, opacity: 0.7 }}
              data-testid="save-quote-cancel"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onSave}
              disabled={savingQuote}
              className="pcp-mono text-[11px] px-4 py-2 rounded inline-flex items-center gap-2"
              style={{ background: SUN, color: INK, opacity: savingQuote ? 0.6 : 1 }}
              data-testid="save-quote-submit"
            >
              <Save className="h-3.5 w-3.5" /> {savingQuote ? "Saving…" : "Save quote"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
